import React from 'react';
import ReactDOM from 'react-dom';
import bugsnag from 'bugsnag-js'
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import firebase from 'firebase/app';
import 'firebase/firebase';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import * as environments from './environments';

import { StripeProvider } from 'react-stripe-elements';

import MuiPickersUtilsProvider from 'material-ui-pickers/utils/MuiPickersUtilsProvider';
import MomentUtils from 'material-ui-pickers/utils/moment-utils';

import createPlugin from 'bugsnag-react'

const bugsnagClient = bugsnag('f0953a9407e1fa3f9ecd7cf483cda61bFAKE')

const theme = createMuiTheme({

    // overrides: {
    //     MuiInput: {
    //       underline: {
    //         '&:before': { //underline color when textfield is inactive
    //           backgroundColor: 'red',
    //         },
    //         '&:hover:not($disabled):before': { //underline color when hovered 
    //           backgroundColor: 'green',
    //         },
    //     }
    // },

    palette: {
        primary: {
            main: '#66BB6A',
            // main: '#8F100F'
        },
        secondary: {
            main: '#FFFFFF',
        },
        action: {
            main: '#4C4C4C',
            // hover: '#2E2E2E',
        },
        error: {
            main: '#EF5350',
        },
        disabled: {
            main: '#E6E6E6',
        },
        drawerHeader: '#4C4C4C',
        drawerBackground: '#424242',
        pageHeader: '#3D4251',

    },

});

if (environments.useProduction) {
    var config = {
        apiKey: "AIzaSyDAVHfbavnHBvRBjjvyUOwHxPcRB-GqR9w",
        authDomain: "realtor-rewards.firebaseapp.com",
        databaseURL: "https://realtor-rewards.firebaseio.com",
        projectId: "realtor-rewards",
        storageBucket: "realtor-rewards.appspot.com",
        messagingSenderId: "711146621511"
        };
} else {
    var config = {
        apiKey: "AIzaSyDuLvSEqth0mn4lX7wjdfsrui_t38-E0rs",
        authDomain: "realtor-rewards-dev.firebaseapp.com",
        databaseURL: "https://realtor-rewards-dev.firebaseio.com",
        projectId: "realtor-rewards-dev",
        storageBucket: "realtor-rewards-dev.appspot.com",
        messagingSenderId: "514924590771"
    };
}

firebase.initializeApp(config);

// wrap your entire app tree in the ErrorBoundary provided
const ErrorBoundary = bugsnagClient.use(createPlugin(React))


ReactDOM.render(
    <ErrorBoundary>
        <MuiThemeProvider theme={theme}>
            <MuiPickersUtilsProvider utils={MomentUtils}>
                <StripeProvider apiKey="pk_live_lUrIHaylV203RYM1dHNUz4Q7">
                    <App />
                </StripeProvider>
            </MuiPickersUtilsProvider>
        </MuiThemeProvider>
    </ErrorBoundary>, 
document.getElementById('root'));
registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.js